/**
 * Formatação do módulo — spec 0061.
 *
 * `brl`, `dia` e `quando` estavam redefinidos no topo de cada tela, com
 * pequenas diferenças entre eles. O bpm tem o mesmo problema, em sete cópias.
 */

/** Dinheiro em reais. Aceita número ou a string que o servidor devolve. */
export const brl = (v: unknown): string =>
  Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

/**
 * Data de calendário (coluna `date`), lida como TEXTO.
 *
 * `new Date('2026-11-20')` é meia-noite UTC — em Brasília vira 19/11. Pegar os
 * dez primeiros caracteres e fixar meio-dia elimina o deslize de um dia.
 */
export const dia = (v: string | null | undefined): string =>
  v ? new Date(`${String(v).slice(0, 10)}T12:00:00`).toLocaleDateString('pt-BR') : '—';

/** Instante (`timestamptz`), com hora. */
export const quando = (v: string | null | undefined): string =>
  v ? new Date(v).toLocaleString('pt-BR') : '—';

/**
 * Hoje em Brasília, como `AAAA-MM-DD` — para valor inicial de campo `date` (0090).
 *
 * `new Date().toISOString().slice(0, 10)` é o dia em UTC: depois das 21h ele já
 * é amanhã, e a vigência nascia com um dia a mais.
 */
export const hojeBRT = (): string =>
  new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Sao_Paulo' }).format(new Date());
